export default __webpack_public_path__ + "static/media/projectLogo.dff25c35.jpg";